import React from 'react';
import { Link } from 'react-router-dom';
import LayoutWrapper from '../layout/LayoutWrapper'
import PrivacyPolicyView from './PrivacyPolicyView';
import TermsAndConditionsView from './TermsAndConditionsView';


export default LayoutWrapper(PrivacyPolicyView, {showNavigationBar:true, showSideMenu:true});